import { createQuery } from 'react-query-kit';
import { ErrorResponse, ModifiedByUser, privateApi } from 'api';
import { AxiosError } from 'axios';

export type GetPaymentParams = {
    id: string;
}

export type Payment = {
    tenant_id: string;
    id: string;
    student_user_id: string;
    date: string;
    amount: number;
    amount_allocated: string | null; // bigint string
    amount_refunded: string | null; // bigint string
    memo?: string | null;
    description?: string | null;
    private_notes?: string | null;
    payment_method_id: string | null;
    payment_method: {
        tenant_id: string;
        id: string;
        name: string;
        enabled: boolean;
        allow_method_for_payment: boolean;
        allow_method_for_refund: boolean;
    };
    check_no: string | null;
    received_from: string | null;
    voided: boolean;
    reason_voided?: string | null;
    voided_by?: string | null;
    voided_at?: string | null;
    created_by?: string | null;
    des_id?: string | null;
    created_at: string | null;
    updated_by: string | null;
    updated_at: string | null;
    voided_by_user: ModifiedByUser | null;
    created_by_user: ModifiedByUser | null;
    updated_by_user: ModifiedByUser | null;
    student_charge_payments: {
        tenant_id: string;
        student_charge_id: string;
        student_payment_id: string;
        amount: number;
    }[];
    student_payment_refunds: {
        tenant_id: string;
        student_payment_id: string;
        student_refund_id: string;
        amount: number;
    }[];
}

export type GetPaymentResult = Payment | null;

async function getPayment(params: GetPaymentParams): Promise<GetPaymentResult | null> {

    if (!params.id) {
        return null;
    }

    // make api call
    const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/finance/payments/${params.id}`);

    // return the data object
    return result.data as GetPaymentResult;
}

const useGetPayment = createQuery<GetPaymentResult, GetPaymentParams, AxiosError<ErrorResponse>>({
    queryKey: ['payment'],
    fetcher: (variables) => getPayment(variables),
})

export { useGetPayment };

